let pixels = {};
let debugEnabled = false;

const state = {
  insertion: "us",
  last3dInteractionAt: 0,
};

const INTERACTION_3D_COOLDOWN_MS = 800;

function debugLog(message, payload) {
  if (!debugEnabled) return;
  if (payload !== undefined) {
    console.log(`[pixels] ${message}`, payload);
    return;
  }
  console.log(`[pixels] ${message}`);
}

function fire(key) {
  const url = pixels[key];
  if (!url) {
    debugLog(`MISSING key: ${key}`);
    return;
  }
  const img = new Image();
  img.referrerPolicy = "no-referrer-when-downgrade";
  img.decoding = "async";
  debugLog(`FIRE key: ${key}`, { insertion: state.insertion, url });
  img.src = url;
}

// --- Public API ---
export const setTrackingDebug = (enabled) => {
  debugEnabled = !!enabled;
  debugLog(`debug mode: ${debugEnabled ? "ON" : "OFF"}`);
};

export const initTracking = (cfg) => {
  pixels = cfg?.pixels || {};
  state.insertion = cfg?.insertion || state.insertion;
  state.last3dInteractionAt = 0;
  debugLog("init", {
    insertion: state.insertion,
    keys: Object.keys(pixels),
  });
};

export const trackViewInAr = () => {
  fire("view-in-ar");
  console.log("Tracked: View in AR");
};

export const trackViewIn3d = () => {
  fire("view-in-3d");
  console.log("Tracked: View in 3D");
};

export const trackLearnMore = () => {
  fire("learn-more");
  console.log("Tracked: Learn more");
};

export const trackColorSelection = (variantName) => {
  if (variantName === "blue") {
    fire("blue");
    console.log("Tracked: Blue selection");
  } else if (variantName === "black") {
    fire("black");
    console.log("Tracked: Black selection");
  } else if (variantName === "silver") {
    fire("titanium");
    console.log("Tracked: Titanium selection");
  }
};

export const track3dInteraction = () => {
  const now = Date.now();
  if (now - state.last3dInteractionAt < INTERACTION_3D_COOLDOWN_MS) {
    debugLog("SKIP key: interaction-3d (cooldown)");
    return;
  }
  state.last3dInteractionAt = now;
  fire("interaction-3d");
  console.log("Tracked: 3D interaction");
};
